import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
// Arte fijo del codigo, no una imagen subida desde el panel: va importada para que
// se empaquete con el build en vez de vivir en public/images/rewards (ignorado en git).
import comandoRecompensa from './images/comandorecompensa.png';
// Los drops se ilustran con el logo de la plataforma donde han caido: es justo el dato
// que hay que leer de un vistazo. Tambien van importados, por lo mismo.
import twitchLogo from './images/twitchLogoSquare.png';
import youtubeLogo from './images/youtubeLogoSquare.png';
import kickLogo from './images/kickLogoSquare.png';
import tiktokLogo from './images/tiktokLogoSquare.png';
import starviosLogo from './images/starviosLogoSquare.png';
// Las mascotas del canal: cada follow sale con una al azar.
import mascota from './images/mascota.png';
import mascotaLogin from './images/mascotaLogin.png';
import over256 from './images/over256.png';
import heroe256 from './images/heroe256.png';
import villano256 from './images/villano256.png';

const mascotas = [mascota, mascotaLogin, over256, heroe256, villano256];
const randomMascota = () => mascotas[Math.floor(Math.random() * mascotas.length)];
// Y en la esquina de la mascota, el icono de la plataforma donde ha seguido.
const platformIcons = { twitch: twitchLogo, youtube: youtubeLogo, kick: kickLogo, tiktok: tiktokLogo, starvios: starviosLogo };

const socket = io('https://forallia.com');

const alertParams = new URLSearchParams(window.location.search);

// Ajuste fino del tamano de la alerta sin redeploy, por si el escalado automatico
// no cuadra con el ancho del browser source: &scale=1.4
const alertScale = (() => {
    const raw = parseFloat(alertParams.get('scale'));
    if (!isFinite(raw) || raw <= 0) return 1;
    return Math.min(3, Math.max(0.5, raw));
})();

// Clave del panel: sin ella el servidor no arranca timers ni manda nada al chat.
// Se pasa en la URL del browser source: ?streamGadgets=rewardsHistory&key=...
const panelKey = alertParams.get('key') || '';

// Alerta de mentira para poder afinar tamanos redimensionando la ventana, sin tener que
// crear recompensas reales en produccion: &preview=code | reward | timerStart | timerEnd | drop | event | follow
// (follow admite &platform=twitch | youtube | kick | tiktok | starvios)
const previewMode = alertParams.get('preview');
// Solo el preview usa imageSrc: las recompensas reales traen el nombre de fichero
// en .image y se sirven desde /images/rewards.
const previewBase = {
    name: 'Recompensa con un nombre bastante largo de prueba',
    displayname: 'UsuarioConNombreMuyLargo',
    imageSrc: comandoRecompensa,
    durationText: '3 minutos',
    id: 'preview',
};
const previewReward =
    previewMode === 'code'
        ? { kind: 'code', code: 'SUPERCOMANDO', points: 5000, id: 'preview' }
        : previewMode === 'reward'
            ? previewBase
            : previewMode === 'timerStart'
                ? { ...previewBase, kind: 'timerStart' }
                : previewMode === 'timerEnd'
                    ? { ...previewBase, kind: 'timerEnd' }
                    : previewMode === 'drop'
                        ? { kind: 'drop', platform: 'twitch', title: 'Spray de Calavela de Brawl Stars', id: 'preview' }
                        : previewMode === 'event'
                            ? { kind: 'event', title: 'Hablar con acento argentino', imageSrc: comandoRecompensa, id: 'preview' }
                            : previewMode === 'follow'
                                ? { kind: 'follow', name: 'UsuarioConNombreMuyLargo', platform: alertParams.get('platform') || 'twitch', mascot: randomMascota(), id: 'preview' }
                                : null;

// mm:ss a partir de los milisegundos que quedan.
const formatClock = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const mm = String(Math.floor(total / 60)).padStart(2, '0');
    const ss = String(total % 60).padStart(2, '0');
    return mm + ':' + ss;
};

// Funcion 'tts' de una recompensa (apps/rewardFunctions.js): lee en voz alta el texto del
// usuario. Arranca un segundo despues para no pisar el aviso, y se resuelve cuando acaba, si
// el audio no carga o al llegar al tope, para que la cola de alertas no se quede colgada.
const TTS_MAX_MS = 30000;
// Decibelios de mas para la voz respecto a los demas sonidos del overlay (+6 dB = el doble de
// amplitud). El volumen de un <audio> no pasa del 100%, asi que se sube con Web Audio. Si se
// pasa, distorsiona: probarlo en OBS.
const TTS_GAIN_DB = 6;
let ttsContext = null;
const louder = (audio) => {
    ttsContext = ttsContext || new AudioContext();
    const gain = ttsContext.createGain();
    gain.gain.value = Math.pow(10, TTS_GAIN_DB / 20);
    ttsContext.createMediaElementSource(audio).connect(gain).connect(ttsContext.destination);
    return ttsContext.resume();
};
const playTts = (rewardHistoryId) => new Promise(resolve => {
    const audio = new Audio('/api/tts?id=' + rewardHistoryId);
    const giveUp = setTimeout(() => { audio.pause(); resolve(); }, TTS_MAX_MS);
    const done = () => { clearTimeout(giveUp); resolve(); };
    audio.onended = done;
    audio.onerror = done;
    setTimeout(() => louder(audio).then(() => audio.play()).catch(done), 1000);
});

// Mismo marco que en la tienda y el inventario (ver rewards.jsx): 0 Neutro, 1 Heroe, 2 Villano.
// El neutro se queda sin clase para heredar el borde partido verde/rojo por defecto.
const karmaBoxClass = (karmaType) => {
    const karma = Number(karmaType);
    return karma === 1 ? 'heroesBox' : karma === 2 ? 'villanoBox' : '';
};

const RewardsHistory = ({ stream }) => {
    const [rewards, setRewards] = useState([]);
    const [lastReward, setLastReward] = useState(previewReward);
    const [rewardQueue, setRewardQueue] = useState([]);
    const [isShowingReward, setIsShowingReward] = useState(false);
    const [copiedId, setCopiedId] = useState(null);
    // Reembolso en dos clicks: el primero arma el boton, el segundo devuelve los birux.
    const [refundArmedId, setRefundArmedId] = useState(null);
    // Timers en curso. Cada uno lleva su deadline en reloj LOCAL, no el endsAt del
    // servidor: el PC de OBS puede ir desfasado y la cuenta atras saldria mal.
    const [activeTimers, setActiveTimers] = useState([]);
    const [nowTs, setNowTs] = useState(Date.now());
    const [keyError, setKeyError] = useState(false);
    // Eventos del directo que han saltado (apps/streamEvents.js). En el panel van aparte de
    // las recompensas: no son de ningun usuario y se descartan con un click.
    const [streamEvents, setStreamEvents] = useState([]);
    const [dismissedEvents, setDismissedEvents] = useState([]);

    const toLocalTimer = (timer) => ({ ...timer, deadline: Date.now() + timer.remainingMs });

    const getRewardsHistory = () => {
        fetch('/api/rewards?action=history', { method: 'POST' })
            .then(response => response.json())
            .then(data => {
                const items = data
                    .slice()
                    .map(item => ({
                        name: item.name,
                        image: item.image,
                        displayname: item.displayname,
                        rewardHistoryId: item.id,
                        userText: item.userText || '',
                        karmaType: item.karmaType ?? 0,
                        hasTimer: item.hasTimer === true,
                        timerSeconds: item.timerSeconds || 0,
                        refundable: item.refundable === true,
                        skipQueue: item.skipQueue === true,
                    }));
                setRewards(items);
            })
            .catch(error => console.error('Error fetching rewards history:', error));
    };

    // Al recargar el panel se recuperan los que ya saltaron en este directo.
    const getStreamEvents = () => {
        fetch('/api/rewards?action=firedEvents', { method: 'POST' })
            .then(response => response.json())
            .then(list => setStreamEvents(Array.isArray(list) ? list : []))
            .catch(error => console.error('Error fetching stream events:', error));
    };

    // Los timers viven en el servidor, asi que al recargar el panel (o al abrir OBS a
    // media sesion) hay que pedirlos en vez de esperar al proximo evento de socket.
    const getActiveTimers = () => {
        fetch('/api/rewards?action=activeTimers', { method: 'POST' })
            .then(response => response.json())
            .then(list => setActiveTimers((list || []).map(toLocalTimer)))
            .catch(error => console.error('Error fetching active timers:', error));
    };

    const handleUseReward = (rewardHistoryId) => {
        const url = '/api/rewards?action=useReward&rewardHistoryId=' + rewardHistoryId +
            (panelKey ? '&key=' + encodeURIComponent(panelKey) : '');
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        }).then(response => response.json())
            .then(data => {
                // Sin clave el servidor no ha tocado nada: la fila sigue pendiente y
                // se puede reintentar tras corregir la URL, asi que no se refresca.
                if (data.error === 'invalid_key') {
                    setKeyError(true);
                    return;
                }
                if (data.success) {
                    setKeyError(false);
                    getRewardsHistory();
                }
            })
            .catch(error => console.error('Error using reward:', error));
    };

    const handleRefund = (rewardHistoryId) => {
        if (refundArmedId !== rewardHistoryId) {
            setRefundArmedId(rewardHistoryId);
            setTimeout(() => setRefundArmedId(prev => (prev === rewardHistoryId ? null : prev)), 3000);
            return;
        }
        setRefundArmedId(null);
        const url = '/api/rewards?action=refundReward&rewardHistoryId=' + rewardHistoryId +
            (panelKey ? '&key=' + encodeURIComponent(panelKey) : '');
        fetch(url, { method: 'POST' })
            .then(response => response.json())
            .then(data => {
                if (data.error === 'invalid_key') {
                    setKeyError(true);
                    return;
                }
                if (data.success) setKeyError(false);
                getRewardsHistory();
            })
            .catch(error => console.error('Error refunding reward:', error));
    };

    useEffect(() => {
        socket.on('reward', ([rewardName, userName, image, id, userText, karmaType, fn, skipQueue]) => {
            const newReward = {
                name: rewardName,
                displayname: userName,
                image: image,
                rewardHistoryId: id,
                userText: userText || '',
                karmaType: karmaType ?? 0,
                fn: fn || '',
                skipQueue: skipQueue === true,
                isNew: true,
                id: Date.now(),
            };
            // La que salta la cola se pone delante de las alertas que esperan, pero detras
            // de otras que tambien la salten: entre ellas se respeta el orden de llegada.
            setRewardQueue(prev => {
                const firstWaiting = newReward.skipQueue ? prev.findIndex(r => !r.skipQueue) : -1;
                const at = firstWaiting === -1 ? prev.length : firstWaiting;
                return [...prev.slice(0, at), newReward, ...prev.slice(at)];
            });
            setRewards(prev => {
                const actualizados = [...prev.map(r => ({ ...r, isNew: false })), newReward];
                return actualizados.slice(-200);
            });
        });

        // Los comandos recompensa creados desde el admin solo entran en la cola de
        // alertas: no son recompensas de usuario, asi que no van a la lista del historial.
        socket.on('codeReward', ([code, points]) => {
            setRewardQueue(prev => [...prev, {
                kind: 'code',
                code: code,
                points: points,
                id: Date.now(),
            }]);
        });

        // El enlace del drop ya esta publicado en el chat de su plataforma; aqui solo se
        // avisa de DONDE ha caido, para que el que este mirando la pantalla corra al sitio.
        socket.on('articleDrop', (drop) => {
            setRewardQueue(prev => [...prev, {
                kind: 'drop',
                ...drop,
                id: Date.now(),
            }]);
        });

        // Follow en cualquier plataforma (apps/chat.js follow): una mascota al azar le da la bienvenida.
        socket.on('follow', ({ name, platform }) => {
            setRewardQueue(prev => [...prev, { kind: 'follow', name: name, platform: platform, mascot: randomMascota(), id: Date.now() }]);
        });

        // Evento del directo: sale como una recompensa ("EVENTO: Titulo") y, en el panel,
        // con su descripcion para saber que hay que hacer.
        socket.on('streamEvent', (event) => {
            setRewardQueue(prev => [...prev, { kind: 'event', ...event, id: Date.now() }]);
            setStreamEvents(prev => [...prev.filter(e => e.fireId !== event.fireId), event].slice(-50));
        });

        // Recompensas temporales: el servidor lleva el reloj y avisa del inicio y del fin.
        socket.on('rewardTimerStart', (timer) => {
            setActiveTimers(prev => [
                ...prev.filter(t => t.rewardHistoryId !== timer.rewardHistoryId),
                toLocalTimer(timer)
            ].sort((a, b) => a.deadline - b.deadline));
            setRewardQueue(prev => [...prev, { kind: 'timerStart', ...timer, id: Date.now() }]);
        });

        socket.on('rewardTimerEnd', (timer) => {
            setActiveTimers(prev => prev.filter(t => t.rewardHistoryId !== timer.rewardHistoryId));
            setRewardQueue(prev => [...prev, { kind: 'timerEnd', ...timer, id: Date.now() }]);
        });

        if (rewards.length === 0) {
            getRewardsHistory();
        }
        getActiveTimers();
        getStreamEvents();
        // Tras una reconexion se han podido perder eventos: se vuelve a sincronizar.
        socket.on('connect', getActiveTimers);

        return () => {
            socket.off('reward');
            socket.off('codeReward');
            socket.off('articleDrop');
            socket.off('follow');
            socket.off('streamEvent');
            socket.off('rewardTimerStart');
            socket.off('rewardTimerEnd');
            socket.off('connect', getActiveTimers);
        };
    }, []);

    // Tick de la cuenta atras. Solo en el panel y solo si hay algo que contar: el
    // overlay no muestra timers y no tiene por que repintarse cada segundo.
    useEffect(() => {
        if (stream !== 0 || activeTimers.length === 0) return;
        const interval = setInterval(() => setNowTs(Date.now()), 1000);
        return () => clearInterval(interval);
    }, [stream, activeTimers.length]);

    // Copia sin consumir la recompensa. El API moderno solo existe en contextos seguros,
    // y la lista se abre a menudo como browser source de OBS, asi que hay fallback.
    const copyText = (text, rewardHistoryId) => {
        const markCopied = () => {
            setCopiedId(rewardHistoryId);
            setTimeout(() => setCopiedId(prev => (prev === rewardHistoryId ? null : prev)), 1500);
        };
        const fallbackCopy = () => {
            try {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                markCopied();
            } catch (error) {
                console.error('No se pudo copiar el texto:', error);
            }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(markCopied).catch(fallbackCopy);
        } else {
            fallbackCopy();
        }
    };

    const playAlertSound = () => {
        const audio = new Audio('/audio/boton.mp3');
        audio.play().catch(error => {
            console.warn('No se pudo reproducir el audio:', error);
        });
    };

    // La alerta se superpone al video en OBS, asi que el fondo opaco del html sobra.
    useEffect(() => {
        if (stream !== 2) return;
        document.documentElement.style.backgroundColor = 'transparent';
    }, [stream]);

    useEffect(() => {
        // En preview la alerta se queda fija en pantalla para poder mirarla con calma.
        if (previewReward) return;
        const interval = setInterval(() => {
            if (!isShowingReward && rewardQueue.length > 0) {
                const nextReward = rewardQueue[0];
                setLastReward(nextReward);
                setIsShowingReward(true);
                playAlertSound();

                // Con voz, la alerta aguanta en pantalla hasta que termina de leerse el texto.
                // Solo suena en la alerta: el panel y la lista estan abiertos a la vez y se
                // oiria repetida.
                const speaks = stream === 2 && nextReward.fn === 'tts' && nextReward.userText;
                Promise.all([
                    new Promise(resolve => setTimeout(resolve, 5000)),
                    speaks ? playTts(nextReward.rewardHistoryId) : null,
                ]).then(() => {
                    setLastReward(null);
                    setIsShowingReward(false);
                    // No tiene por que seguir la primera: mientras se mostraba ha podido
                    // colarse delante una que salta la cola.
                    setRewardQueue(prev => prev.filter(r => r !== nextReward));
                });
            }
        }, 500);

        return () => clearInterval(interval);
    }, [isShowingReward, rewardQueue]);

    if (stream === 0) {
        return (
            <div className='heroes'>
                <div className='rewardsHistory'>Últimas recompensas usadas</div>
                {keyError ? (
                    <div className='rewardTimerKeyWarn'>
                        Falta la clave: añade <span className='userLink'>&amp;key=...</span> a la URL del panel para activar recompensas temporales
                    </div>
                ) : ''}
                {activeTimers.length > 0 ? (
                    <div className='rewardTimersPanel'>
                        {activeTimers.map(timer => {
                            const left = Math.max(0, timer.deadline - nowTs);
                            return (
                                <div key={timer.rewardHistoryId}
                                    className={'rewardTimerRow' + (left <= 10000 ? ' rewardTimerEnding' : '')}>
                                    {timer.image ? <img src={'/images/rewards/' + timer.image} alt={timer.name} /> : ''}
                                    <div className='rewardTimerInfo'>
                                        <span className='rewardTimerName'>{timer.name}</span>
                                        <span className='userLink'>{timer.displayname}</span>
                                    </div>
                                    <span className='rewardTimerClock'>{formatClock(left)}</span>
                                </div>
                            );
                        })}
                    </div>
                ) : ''}
                {streamEvents.filter(e => !dismissedEvents.includes(e.fireId)).map(event => (
                    <div className='infoBox streamEventItem' key={event.fireId}
                        onClick={() => setDismissedEvents(prev => [...prev, event.fireId])}>
                        <div>
                            {event.image ? <img src={'/images/rewards/' + event.image} alt={event.title} /> : ''}
                            <div className='textReward'>
                                <span className='userLink'>EVENTO: {event.title}</span>
                                {event.test ? <span className='rewardTimerBadge'>prueba</span> : ''}
                                {event.description ? <div className='rewardUserText'><span className='rewardUserTextValue'>{event.description}</span></div> : ''}
                            </div>
                        </div>
                    </div>
                ))}
                {/* Las que saltan la cola van arriba; el resto, por orden de llegada (sort es estable). */}
                {[...rewards].sort((a, b) => (b.skipQueue ? 1 : 0) - (a.skipQueue ? 1 : 0)).map((texto, idx) => (
                    <div className='infoBox' key={texto.rewardHistoryId ?? idx}
                        onClick={() => handleUseReward(texto.rewardHistoryId)}>
                        <div className={karmaBoxClass(texto.karmaType)}>
                            <img src={'/images/rewards/' + texto.image} alt={texto.name} />
                            <div className='textReward'>
                                <span className='userLink'>{texto.displayname}</span> ha usado la recompensa por <span className='userLink'>{texto.name}</span>
                                {texto.skipQueue ? <span className='rewardTimerBadge'>⏩ salta la cola</span> : ''}
                                {texto.hasTimer ? (
                                    <span className='rewardTimerBadge'>⏱ {texto.timerSeconds}s</span>
                                ) : ''}
                                {texto.userText ? (
                                    <div className='rewardUserText'>
                                        <span className='rewardUserTextValue'>{texto.userText}</span>
                                        <button className='copyRewardBtn'
                                            onClick={(e) => { e.stopPropagation(); copyText(texto.userText, texto.rewardHistoryId); }}>
                                            {copiedId === texto.rewardHistoryId ? '¡Copiado!' : 'Copiar'}
                                        </button>
                                    </div>
                                ) : ''}
                                {texto.refundable ? (
                                    <button className='copyRewardBtn refundRewardBtn'
                                        onClick={(e) => { e.stopPropagation(); handleRefund(texto.rewardHistoryId); }}>
                                        {refundArmedId === texto.rewardHistoryId ? '¿Seguro?' : 'Reembolsar'}
                                    </button>
                                ) : ''}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (stream === 1) {
        return (<div className='heroes'>
            {rewards.map((texto, idx) => (
                <div key={texto.id}
                    className={`rewardStream ${texto.isNew ? 'show' : ''}`}>
                    <img src={'/images/rewards/' + texto.image} />
                    <span className='userLink'>@{texto.displayname}</span>
                </div>
            ))}
        </div>);
    }

    const alertClass = 'heroes popReward' + (previewReward ? ' popPreview' : '');
    const alertStyle = { '--alertScale': alertScale };

    if (stream === 2 && lastReward && lastReward.kind === 'code') {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={comandoRecompensa} alt={lastReward.code} />
            <span>¡Se ha creado el comando <span className='userLink'>!{lastReward.code}</span>! Úsalo ahora y gana <span className='userLink'>{lastReward.points}</span> birux comodín</span>
        </div>);
    }

    if (stream === 2 && lastReward && lastReward.kind === 'drop') {
        const enYoutube = lastReward.platform === 'youtube';
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={enYoutube ? youtubeLogo : twitchLogo} alt={enYoutube ? 'YouTube' : 'Twitch'} />
            <span>¡Ha caído <span className='userLink'>{lastReward.title}</span> en <span className='userLink'>{enYoutube ? 'YouTube' : 'Twitch'}</span>! El primero que lo pille se lo queda</span>
        </div>);
    }

    if (stream === 2 && lastReward && lastReward.kind === 'follow') {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <div className='popFollow'>
                <img src={lastReward.mascot} alt='' />
                {platformIcons[lastReward.platform] ? <img className='popPlatform' src={platformIcons[lastReward.platform]} alt={lastReward.platform} /> : ''}
            </div>
            <span>¡Bienvenido corrupto <span className='userLink'>{lastReward.name}</span>!</span>
        </div>);
    }

    if (stream === 2 && lastReward && lastReward.kind === 'event') {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={lastReward.imageSrc || ('/images/rewards/' + lastReward.image)} alt={lastReward.title} />
            <span>EVENTO: <span className='userLink'>{lastReward.title}</span></span>
        </div>);
    }

    if (stream === 2 && lastReward && lastReward.kind === 'timerStart') {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={lastReward.imageSrc || ('/images/rewards/' + lastReward.image)} alt={lastReward.name} />
            <span><span className='userLink'>{lastReward.displayname}</span> ha activado <span className='userLink'>{lastReward.name}</span> durante <span className='userLink'>{lastReward.durationText}</span></span>
        </div>);
    }

    if (stream === 2 && lastReward && lastReward.kind === 'timerEnd') {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={lastReward.imageSrc || ('/images/rewards/' + lastReward.image)} alt={lastReward.name} />
            <span>¡Se acabó <span className='userLink'>{lastReward.name}</span> de <span className='userLink'>{lastReward.displayname}</span>!</span>
        </div>);
    }

    if (stream === 2 && lastReward) {
        return (<div key={lastReward.id} className={alertClass} style={alertStyle}>
            <img src={lastReward.imageSrc || ('/images/rewards/' + lastReward.image)} alt={lastReward.name} />
            <span><span className='userLink'>{lastReward.displayname}</span> ha usado la recompensa <span className='userLink'>{lastReward.name}</span></span>
        </div>);
    } else {
        return '';
    }
};

export default RewardsHistory;
